import {
  REQUEST_DESTINATION_DETAILS,
  RECEIVE_DESTINATION_DETAILS,
  DESTINATION_DETAILS_ERROR
} from '../actions/destinations'
import { getActivePackageData } from './activePackage'

const initialState = {
  isLoading: false,
  hasErrors: false,
  items: null
}

const destinations = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DESTINATION_DETAILS:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_DESTINATION_DETAILS:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: false,
        items: action.payload
      })
    case DESTINATION_DETAILS_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: true
      })
    default:
      return state
  }
}

export const getDestinationDetails = state => {
  const activePackage = getActivePackageData(state)

  if (
    !activePackage ||
    !activePackage.destinationCode ||
    !state.destinations.items
  ) {
    return null
  }
  return state.destinations.items.find(
    destination =>
      destination.destination_code === activePackage.destinationCode
  )
}

export default destinations
